// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Chad */
const TD = /^(?:(?:3[01]|[69]\d|77|8[5-7])\d{6})$/;

export default TD;
